/**
 * reasonStats.js — Order Alerts reason-coverage helpers (pure).
 */

/**
 * Whether a stored reason value counts as a real, entered reason.
 * Treats null/undefined and whitespace-only strings as "no reason".
 */
export function hasReason(reason) {
  return typeof reason === 'string' ? reason.trim().length > 0 : !!reason;
}

/**
 * Summarize reason-entry coverage for the Order Alerts tab.
 *
 * All counts are computed over the SAME population (the open misc tickets passed
 * in), so the invariant `needsReasonCount + reasonedCount === openCount` always
 * holds.
 *
 * @param {Array} openMiscTickets — the open misc tickets to summarize
 * @param {Object} reasons        — { [ticketId]: reasonString|null }
 */
export function summarizeReasonStats(openMiscTickets, reasons) {
  const list = Array.isArray(openMiscTickets) ? openMiscTickets : [];
  const map = reasons || {};
  const openCount = list.length;
  const revenueCents = list.reduce((s, t) => s + (t.revenueCents || 0), 0);
  const reasonedCount = list.filter(t => hasReason(map[t.id])).length;
  return { openCount, revenueCents, reasonedCount, needsReasonCount: openCount - reasonedCount };
}

/**
 * Accurate empty-state copy for the Order Alerts table — distinguishes "no open
 * orders" from "open orders all hidden by threshold/filters".
 */
export function oaEmptyStateMessage({ openMiscCount, hasActiveFilters }) {
  if (!openMiscCount) return 'No open misc orders in this period.';
  if (hasActiveFilters) return 'No orders match the current column filters.';
  return 'No open misc orders above the alert threshold.';
}
